export const LocalStorageKey = {
  CV_VIEWER_WIDTH: 'CV_VIEWER_WIDTH',
  LAST_VISITED_PAGE: 'LAST_VISITED_PAGE',
  LAYOUT_STATE_PER_ROUTE: 'LAYOUT_STATE_PER_ROUTE',
  TABLE_ID_KEY_COLUMN_VISIBILITY: 'TABLE_ID_KEY_COLUMN_VISIBILITY',
  TAG_EXPRESSION_BUILDER_MODE: 'TAG_EXPRESSION_BUILDER_MODE',
} as const;

export type LocalStorageKey = (typeof LocalStorageKey)[keyof typeof LocalStorageKey];

const setItem = (param: LocalStorageKey, value: unknown) => {
  localStorage.setItem(param, JSON.stringify(value));
};

const getItem = <T = string>(key: LocalStorageKey): T | null => {
  const item = localStorage.getItem(key);
  if (item === null) return null;
  return JSON.parse(item);
};

const clearItem = (key: LocalStorageKey): void => {
  localStorage.removeItem(key);
};

export const localStorageUtil: {
  clearItem: (key: LocalStorageKey) => void;
  getItem: <T>(key: LocalStorageKey) => T | null;
  setItem: (key: LocalStorageKey, value: unknown) => void;
} = {
  clearItem,
  getItem,
  setItem,
};
